<template>
  <a-card size="small" title="筛选条件" :bordered="false">
    <a-form-model class="search-form">
      <a-form-model-item>
        <span style="margin-right: 8px">时间:</span>
        <a-range-picker v-model="checkedDate" :default-value="checkedDate" :allow-clear="false" />
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>

<script>
import moment from 'moment/moment';

export default {
  data() {
    return {
      checkedDate: [moment().subtract(1, 'month').add(1, 'day'), moment()]
    };
  },
  computed: {
    filter() {
      const { checkedDate } = this;
      return {
        checkedDate
      };
    }
  },
  watch: {
    filter() {
      this.$emit('change', this.checkedDate);
    }
  },
  methods: {
    onChange(checkedDate) {
      this.filterForm = {
        begin_date: checkedDate[0].format('YYYY-MM-DD'),
        end_date: checkedDate[1].format('YYYY-MM-DD')
      };
    }
  }
};
</script>

<style scoped lang="less">

</style>
